import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { Text } from '@nike/podium';
/**
 * ModelOverviewContent - Model-specific overview for EntitySidebar
 *
 * TODO: Implement model overview rendering
 * - Model-level fields (modelName, franchise, silhouette, etc.)
 *
 * Note: ImageGallery is rendered by parent EntitySidebar component.
 */
function ModelOverviewContent({ model }) {
    return (_jsxs("div", { className: "space-y-4", children: [_jsxs(Text, { children: ["Model detail view will be implemented in a future update. Model ID:", ' ', model.modelId] }), _jsx("pre", { className: "text-xs bg-gray-100 p-4 rounded overflow-auto max-h-96", children: JSON.stringify(model, null, 2) })] }));
}
export default ModelOverviewContent;
